<template>
  <div v-tooltip="tooltip"
       v-click-outside="onclickoutside"
       :id="$attrs['id']"
       :class="[ 'room-reservation', {'room-reservation--unskew': unskew }, {'departed': reservation.status === 'Departed' }, {'arrived': !canResizeLeft}, {'no-resize': !canResizeLeft && !canResizeRight},
                 {'room-reservation--update-in-progress': updateInProgress },
                 {'room-reservation--edit-mode': editMode },
                 {'departed': reservation.status === 'Departed'}, {'room-locked': !canMove}, { 'incomplete-left': (daysCutOffLeft > 0) },
                 roomTypeColorClass, reservation.colorCategoryCssClass, $attrs['class'],
                 {'room-reservation--draft': draft }]"
       :style="style"
       @contextmenu.prevent="$emit('contextmenu', $event)"
       @mouseenter="onmouseenter"
       @mouseleave="onmouseleave"
       @click="onclick"
       @dblclick="openReservation()"
       @mouseover="emit('reservation-mouseover')">
    <div class="resize--left" @mousedown="emit('resize-left-mousedown')" @mouseup="emit('resize-left-mouseup')" @touchstart="emit('resize-left-touchstart')"></div>
    <div class="label__wrapper"
         @click="emit('move-click')"
         @mousemove="emit('reservation-mousemove', $event)"
         @touchmove="emit('reservation-touchmove', $event)"
         @mousedown="onmovemousedown"
         @mouseup="onmovemouseup"
         @touchstart="onmovetouchstart"
         @touchend="onmovetouchend"
         @touchcancel="onmovetouchend">
      <!--      <i class="fal fa-plane" style="line-height:calc(var(&#45;&#45;line-height) * 1px);font-size:80%;padding-right:1px;"></i>-->
      <icon v-if="reservation.roomNumberLocked === true" icon="fill-lock" />
      <icon v-if="!isEmpty(reservation.requestExpirationDate)" icon="fill-onrequest" />
      <template v-if="displayPaymentStatus">
        <i v-if="paid" class="fas fa-check fa--roomplan" />
        <i v-if="unpaid" class="fas fa-exclamation-triangle fa--roomplan" />
      </template>
      <i v-if="hasLicense('LinkedRooms') && !isEmpty($parent.linkedRooms[reservation.roomNumber])" class="fas fa-link fa--roomplan"></i>
      <template v-if="hotelSettings.details.additionalFields.ROOMPLAN_CHANNEL_ICONS && is3rdPartySource && !isEmpty(reservation.sourceName)">
        <source-icon :source="reservation.sourceName" />
      </template>
      <template v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.HMC_ROOMPLAN_ICONS)">
        <template v-for="icon in JSON.parse(reservation.additionalFields.HMC_ROOMPLAN_ICONS)">
          <i :class="`fas fa-${icon} fa--roomplan`"></i>
        </template>
      </template>
      <span v-if="hasRole('ROLE_USER')" class="label privacy--blur" v-safe-html="displayName"></span>
      <span v-else class="label privacy--blur" v-safe-html="displayName.replace(/[^\s]/g,'*')"></span>
      <div class="tooltip" style="display: none;">
        <template v-if="hasRole('ROLE_USER')">
          <span class="tooltip__name privacy--blur"><b>{{ displayName }}</b></span>
          <span v-if="!isEmpty(reservation.companyName)" class="privacy--blur" v-safe-html="reservation.companyName"></span>
          <span v-if="!isEmpty(reservation.travelAgentCompanyName)" class="privacy--blur" v-safe-html="reservation.travelAgentCompanyName"></span>
          <span>{{ reservation.checkInDate | toDate }} - {{ reservation.checkOutDate | toDate }}</span>
          <span>{{ reservation.numAdults + (reservation.numChildren || 0) }} {{ $t('roomplan.roomplanReservation.numPersons') }} ({{ reservation.numAdults }} {{ $t('roomplan.roomplanReservation.numAdults') }}/{{ reservation.numChildren || 0 }} {{ $t('roomplan.roomplanReservation.numChildren') }})</span>
          <span v-if="!isEmpty(reservation.roomTypeId)">{{ roomTypeName(reservation.roomTypeId) }}</span>
          <span v-if="!isEmpty(reservation.ratePlanId)">{{ ratePlanName(reservation.ratePlanId) }}</span>
          <span v-if="!isEmpty(reservation.status)">{{ $t('roomplan.roomplanReservation.reservationStatus') }}: {{ $t(`ReservationStatus.${reservation.status}`) }}</span>
          <span v-if="!isEmpty(reservation.colorCategoryCssClass) && !isNil(hotelSettings.details.colorCategoryLabels[reservation.colorCategoryCssClass])">{{ $t('roomplan.roomplanReservation.color') }}: {{ hotelSettings.details.colorCategoryLabels[reservation.colorCategoryCssClass][$shortLocale] }}</span>
          <hr>
          <span v-if="reservation.type === 'OnRequest'">{{ $t('roomplan.roomplanReservation.onRequest') }} {{ reservation.requestExpirationDate | toDate }}</span>
          <span v-if="!isNil(reservation.amount) || !isNil(reservation.shoppingCartAmount)">{{ $t('roomplan.roomplanReservation.totalAmount') }}: {{ (reservation.amount || 0.0) + (reservation.shoppingCartAmount || 0.0) | toCurrency }} {{ reservation.currency }}</span>
          <span v-if="!isEmpty(reservation.sourceName) && reservation.sourceName !== 'Hotelsoftware'" class="ellipsis">{{ $t('roomplan.roomplanReservation.bookingChannel') }}: <source-icon v-if="is3rdPartySource" :source="reservation.sourceName" /> {{ reservation.sourceName }}</span>
          <span v-if="reservation.roomNumberLocked === true">{{ $t('roomplan.roomplanReservation.roomNumberLocked') }}</span>
          <span v-if="hasLicense('LinkedRooms') && $parent.linkedRooms[reservation.roomNumber]"><i class="fa fa-link" />&nbsp;{{ $parent.linkedRooms[reservation.roomNumber].join(' + ') }}</span>
          <span v-if="!isEmpty(reservation.internalComment)" class="privacy--blur"><i>{{ reservation.internalComment }}</i></span>
          <template v-if="!isNil(paymentStatus) && paymentStatus.openBalance === true && !isNil(paymentStatus.balance)">
            <hr>
            <span>
              <template v-if="displayPaymentStatus">
                <i v-if="paid" class="fas fa-check fa--tooltip" />
                <i v-if="unpaid" class="fas fa-exclamation-triangle fa--tooltip" />
              </template>
              {{ $t('roomplan.roomplanReservation.balanceReservation') }}: <b :class="[{'color--red': paymentStatus.balance < 0}]" class="text--bold">{{ paymentStatus.balance | toCurrency }} {{ hotelSettings.details.currency }}</b>
            </span>
          </template>
          <template v-if="!isNil(paymentStatus) && paymentStatus.guestOpenBalance === true && !isNil(paymentStatus.guestBalance)">
            <hr>
            <span>{{ $t('roomplan.roomplanReservation.balanceGuest') }}: <b :class="[{'color--red': paymentStatus.guestBalance < 0}]" class="text--bold">{{ paymentStatus.guestBalance | toCurrency }} {{ hotelSettings.details.currency }}</b></span>
          </template>
          <template v-if="!isEmpty(reservation.additionalFields) && !isEmpty(reservation.additionalFields.HMC_ROOMPLAN_ICONS)">
            <hr>
            <template v-for="icon in JSON.parse(reservation.additionalFields.HMC_ROOMPLAN_ICONS)">
              <i :class="`fas fa-${icon} fa--tooltip`"></i> {{ $t(`pageRoomReservation.icon.${icon}`) }}<br/>
            </template>
          </template>
        </template>
        <template v-else>
          <span class="tooltip__name privacy--blur"><b>{{ displayName.replace(/[^\s]/g,'*') }}</b></span>
          <span>{{ reservation.checkInDate | toDate }} - {{ reservation.checkOutDate | toDate }}</span>
          <span>{{ reservation.numAdults + (reservation.numChildren || 0) }} {{ $t('roomplan.roomplanReservation.numPersons') }} ({{ reservation.numAdults }} {{ $t('roomplan.roomplanReservation.numAdults') }}/{{ reservation.numChildren || 0 }} {{ $t('roomplan.roomplanReservation.numChildren') }})</span>
          <span v-if="!isEmpty(reservation.roomTypeId)">{{ roomTypeName(reservation.roomTypeId) }}</span>
          <span v-if="!isEmpty(reservation.ratePlanId)">{{ ratePlanName(reservation.ratePlanId) }}</span>
          <span v-if="!isEmpty(reservation.sourceName) && reservation.sourceName !== 'Hotelsoftware'" class="ellipsis">{{ $t('roomplan.roomplanReservation.bookingChannel') }}: <source-icon v-if="is3rdPartySource" :source="reservation.sourceName" /> {{ reservation.sourceName }}</span>
        </template>
      </div>
    </div>
    <div class="resize--right" @mousedown="emit('resize-right-mousedown')" @mouseup="emit('resize-right-mouseup')" @touchstart="emit('resize-right-touchstart')">
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */


import { isNil, min, max, isEmpty, isFunction, debounce } from 'lodash';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'RoomplanReservation',

  mixins: [HotelmeisterMixin, TimerMixin],

  props: {
    value: {
      required: true,
    },
    unskew: {
      required: false,
      type: Boolean,
      default: false,
    },
    draft: {
      required: false,
      type: Boolean,
      default: false,
    },
    paymentStatus: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      temp: null,
      reservation: {
        roomNumber: null,
        checkInDate: '19700101',
        checkOutDate: '19700101',
      },
      updateInProgress: false,
      editMode: false,
      anyEditMode: false,
      hovering: false,
      mounted: false,
    };
  },

  computed: {
    displayPaymentStatus: function () {
      return this.hotelSettings.details.additionalFields.ROOMPLAN_PAID_ICONS && !isNil(this.paymentStatus) && this.paymentStatus.anyTransactions;
    },
    paid: function () {
      return this.displayPaymentStatus && !isNil(this.paymentStatus) && this.paymentStatus.openBalance === false && this.paymentStatus.balance === 0.0
        && (this.reservation.status === 'Departed' || this.reservation.status === 'InHouse');
    },
    unpaid: function () {
      return this.displayPaymentStatus && !isNil(this.paymentStatus) && this.paymentStatus.openBalance === true && this.paymentStatus.balance <= 0.0;
    },
    tooltip: function () {
      return {
        mounted: this.mounted,
        title: () => (isNil(this.$el) || isNil(this.$el.querySelector) || isNil(this.$el.querySelector('.tooltip')) ? '' : this.$el.querySelector('.tooltip').innerHTML),
        closeOnClickOutside: true,
        delay: 500,
        theme: 'light',
        placement: 'top',
        trigger: 'hover focus',
        html: true,
        boundariesElement: 'scrollParent',
        // boundariesElement: document.querySelector('.roomplan__container'),
        preventOverflow: true,
        positionFixed: false,
        container: 'parent',
      };
    },
    is3rdPartySource: function () {
      if (!isNil(this.reservation) && !isNil(this.reservation.sourceName) && !['Hotelmeister', 'Hotelsoftware', this.hotelSettings.hotel.whiteLabel].includes(this.reservation.sourceName)) {
        return true;
      } else {
        return false;
      }
    },
    style: function () {
      return {
        '--number-of-nights': this.displayNumberOfNights,
        '--row-number': this.roomNumberPosition,
        '--day-offset': (this.daysOffset),
        '--day-cutoff-left': this.daysCutOffLeft,
      };
    },
    daysOffset: function () {
      const moment = this.$moment;

      if (!isNil(this.temp) && !isNil(this.temp.checkInDate) && !isEmpty(this.temp.checkInDate)) {
        return moment.duration(moment(this.temp.checkInDate, 'YYYYMMDD').diff(moment(this.$parent.startDate, 'YYYYMMDD'))).asDays();
      } else {
        return moment.duration(moment(this.reservation.checkInDate, 'YYYYMMDD').diff(moment(this.$parent.startDate, 'YYYYMMDD'))).asDays();
      }
    },
    daysCutOffLeft: function () {
      return min([this.numberOfNights - 1, (this.daysOffset < 0 ? Math.abs(this.daysOffset) : 0)]);
    },
    roomNumberPosition: function () {
      if (isNil(this.temp) || isEmpty(this.temp.roomNumber)) {
        return isNil(this.roomNumber) ? 10000 : this.$parent.roomNumberPositions[this.roomNumber];
      } else {
        return this.$parent.roomNumberPositions[this.temp.roomNumber];
      }
    },
    displayNumberOfNights: function () {
      const moment = this.$moment;
      if (!isNil(this.temp) && !isNil(this.temp.checkInDate) && !isEmpty(this.temp.checkInDate)) {
        return Math.max(moment.duration(moment(this.reservation.checkOutDate, 'YYYYMMDD').diff(moment(this.temp.checkInDate, 'YYYYMMDD'))).asDays(), 1);
      } else if (!isNil(this.temp) && !isNil(this.temp.checkOutDate) && !isEmpty(this.temp.checkOutDate)) {
        return Math.max(moment.duration(moment(this.temp.checkOutDate, 'YYYYMMDD').diff(moment(this.reservation.checkInDate, 'YYYYMMDD'))).asDays(), 1);
      } else {
        return Math.max(this.numberOfNights, 1);
      }
    },
    roomNumber: function () {
      return this.reservation.roomNumber;
    },
    numberOfNights: function () {
      const moment = this.$moment;
      return isNil(this.reservation.numberOfNights)
        ? moment.duration(moment(this.reservation.checkOutDate, 'YYYYMMDD').diff(moment(this.reservation.checkInDate, 'YYYYMMDD'))).asDays()
        : this.reservation.numberOfNights;
    },
    displayName: function () {
      return [
        this.reservation.guestProfileCompanyName,
        [
          isEmpty(this.reservation.shortInternalComment) ? null : `[${this.reservation.shortInternalComment}]`,
          this.reservation.guestProfileNamePrefix,
          this.hotelSettings.details.roomPlanLastNameFirst === true ? this.reservation.guestProfileLastName : this.reservation.guestProfileFirstName,
          this.reservation.guestProfileMiddleName,
          this.hotelSettings.details.roomPlanLastNameFirst === true ? this.reservation.guestProfileFirstName : this.reservation.guestProfileLastName,
          this.reservation.guestProfileNameSuffix,
        ]
          .filter(it => !isEmpty(it))
          .join(' '),
      ]
        .filter(it => !isEmpty(it))
        .join(' / ');
    },
    roomTypeColorClass: function () {
      return `${isNil(this.$parent.roomTypeMap[this.reservation.roomTypeId]) ? 'roomtype-color--1' : this.$parent.roomTypeMap[this.reservation.roomTypeId].colorClass} ${this.reservation.colorCategoryCssClass}`;
    },
    canResizeLeft: function () {
      if (!isNil(this.reservation) && !isNil(this.reservation.additionalFields) && !isEmpty(this.reservation.additionalFields.managedBy) && this.reservation.additionalFields.managedBy !== 'Hotelmeister') return false;
      return !this.draft && this.reservation.status !== 'InHouse' && this.reservation.status !== 'Departed';
    },
    canResizeRight: function () {
      if (!isNil(this.reservation) && !isNil(this.reservation.additionalFields) && !isEmpty(this.reservation.additionalFields.managedBy) && this.reservation.additionalFields.managedBy !== 'Hotelmeister') return false;
      return this.reservation.status !== 'Departed' && this.reservation.status !== 'DraftCreated';
    },
    canMove: function () {
      return !this.draft && this.reservation.roomNumberLocked !== true;
    },
  },

  watch: {
    'temp.checkOutDate': function (newVal) {
      const temp = this.temp;
      if (isNil(temp)) return;
      if (newVal === 'Invalid Date') {
        temp.checkOutDate = this.$moment(this.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
      }
      if (!this.$moment(newVal, 'YYYYMMDD').isValid() || !this.$moment(newVal, 'YYYYMMDD').isAfter(this.$moment(this.reservation.checkInDate, 'YYYYMMDD'))) {
        temp.checkOutDate = this.$moment(this.reservation.checkInDate, 'YYYYMMDD').add(1, 'day').format('YYYYMMDD');
      }
    },
    // 'temp.checkInDate': function (newVal) {
    //   const temp = this.temp;
    //   if (isNil(temp)) return;
    //   if (newVal === 'Invalid Date') {
    //     temp.checkInDate = this.$moment(this.reservation.checkOutDate, 'YYYYMMDD').add(-1, 'day').format('YYYYMMDD');
    //   }
    //   if (!this.$moment(newVal, 'YYYYMMDD').isValid() || !this.$moment(newVal, 'YYYYMMDD').isBefore(this.$moment(this.reservation.checkOutDate, 'YYYYMMDD'))) {
    //     temp.checkInDate = this.$moment(this.reservation.checkOutDate, 'YYYYMMDD').add(-1, 'day').format('YYYYMMDD');
    //   }
    // },
    editMode: function (newVal, oldVal) {
      if (newVal === true && !isNil(this.$el.tooltip)) {
        this.$el.tooltip.hide();
        this.$el.tooltip.disable();
      } else if (!isNil(this.$el.tooltip)) {
        this.$el.tooltip.enable();
        this.$el.tooltip.show();
      }
    },
  },

  mounted: function () {
    this.$parent.$on('editStarted', (reservationId) => {
      if (reservationId === this.reservation.reservationId) this.editMode = true;
      this.anyEditMode = true;
    });
    this.$parent.$on('editFinished', (reservationId) => {
      if (reservationId === this.reservation.reservationId) this.editMode = false;
      this.anyEditMode = false;
    });

    if (this.reservation.autoEditMode) {
      this.emit('resize-right-mousedown');
    }

    this.mounted = true;
  },

  created: function () {
    this.reservation = this.value;
  },

  methods: {
    ratePlanName: function (ratePlanId) {
      const ratePlan = this.hotelSettings.ratePlans.find(it => it.id === ratePlanId);
      return isNil(ratePlan) ? '-' : ratePlan.name[this.$shortLocale];
    },
    roomTypeName: function (roomTypeId) {
      const roomType = this.hotelSettings.roomTypes.find(it => it.id === roomTypeId);
      return isNil(roomType) ? '-' : roomType.name[this.$shortLocale];
    },
    roomTypeAbbreviation: function (roomTypeId) {
      return this.hotelSettings.roomTypes.find(it => it.id === roomTypeId).abbreviation;
    },
    emit: function (eventName, event = null) {
      this.$parent.$emit(eventName, this, event);
    },
    update: function () {
      if (this.draft) return null;
      return this.axios.get(this.serviceUrls.roomPlanReservation(this, this.reservation.reservationId), {
        params: {},
        headers: {
          Accept: 'application/x-protobuf',
        },
        responseType: 'arraybuffer',
      })
        .then((response) => {
          let roomNumber = null;
          if (this.reservation.roomNumber !== null && this.reservation.roomNumber.startsWith('VR::')) {
            roomNumber = this.reservation.roomNumber;
          }
          // this is required because if I just overwrite the object, the parent (page) doesn't know about the change and causes issues on re-renderings or free room calculations
          this.reservation.roomNumber = response.data.data.roomNumber;
          this.reservation.checkInDate = response.data.data.checkInDate;
          this.reservation.checkOutDate = response.data.data.checkOutDate;
          this.reservation.numberOfNights = response.data.data.numberOfNights;
          this.reservation.roomNumber = isEmpty(this.reservation.roomNumber) ? roomNumber : this.reservation.roomNumber;

          this.$emit('updated');

          // this.$set(this, 'reservation', reservation); // required to prevent any updating issues ...
          return response;
        });
    },
    openReservation: function () {
      if (this.draft) {
        this.$emit('dblclick');
        return;
      }
      this.$router.push({ name: 'reservation', params: { reservationId: this.reservation.reservationId } });
    },
    onclickoutside: function () {
    },
    onclick: function (evt) {
    },
    onmouseenter: function (evt) {
      this.$emit('hoverroomstart', this.roomNumber);
    },
    onmouseleave: function (evt) {
      this.$emit('hoverroomend', this.roomNumber);
    },
    onmovemouseup: function () {
      if (!isNil(this.mousedown)) {
        this.clearTimeout(this.mousedown);
      } else {
        this.emit('move-mouseup');
      }
    },
    onmovemousedown: function () {
      this.mousedown = this.setTimeout(() => {
        this.emit('move-mousedown');
      }, 100);
    },
    onmovetouchstart: function () {
      this.touchstart = this.setTimeout(() => {
        this.emit('move-touchstart');
      }, 100);
    },
    onmovetouchend: function () {
      if (!isNil(this.touchstart)) {
        this.clearTimeout(this.touchstart);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
  //@import '~styles/components/lib/RoomPlanReservation';
  //
  //.room-reservation {
  //  .label__wrapper {
  //    font-weight: 600;
  //  }
  //
  //  &--unskew {
  //    transform: translateX(calc(var(--line-height) / 2 * 1px));
  //
  //    .label__wrapper {
  //      transform: none;
  //      margin-left: calc(var(--line-height) / 2 * 1px);
  //    }
  //  }
  //
  //  &--update-in-progress {
  //    c: wait!important;
  //
  //    * {
  //      pointer-events: none!important;
  //      cursor: wait!important;
  //    }
  //  }
  //
  //  &--edit-mode {
  //    box-shadow: 0px 3px 15px 0 rgba(0,0,0,0.35);
  //  }
  //}

  .tippy-content .hm-icon {
    max-height: 1.4rem;
    width: 2rem;
    display: inline-block!important;
    //top: calc(1.4rem * 0.55 / 2);
    top: 0;
    position: relative;

    /deep/ svg {
      display: flex;
      max-height: 3rem;
      height: 100%;
      position: relative;
      margin-top: -0.6rem;
      max-width: 2rem;
    }
  }

  .fa {
    &--tooltip {
      display: inline-block;
      width: 2.5rem;
    }
    &--roomplan {
      line-height: calc(var(--line-height) * 1px);
      font-size: calc(var(--line-height) * 0.5px - 3px);
      display: inline-block;
      padding-left: 3px;
      padding-top: 1px;

      &:last-of-type {
        padding-right: 3px;
      }
    }
  }
</style>

<style lang="scss">
  @import '~styles/import';
  @import '~styles/components/lib/RoomPlanReservation';

  .room-reservation {
    .label__wrapper {
      font-weight: 600;
    }

    &--unskew {
      transform: translateX(calc(var(--line-height) / 2 * 1px));

      .label__wrapper {
        transform: none;
        margin-left: calc(var(--line-height) / 2 * 1px);
      }
    }

    &--update-in-progress {
      cursor: wait!important;

      * {
        pointer-events: none!important;
        cursor: wait!important;
      }
    }

    &--edit-mode {
      box-shadow: 0px 3px 15px 0 rgba(0,0,0,0.35);
    }
  }

  #myapp.touch .roomplan__layout {
    &:not(.edit-mode) {
      .room-reservation {
        .resize--right, .resize--left, label {
          cursor: default;
          pointer-events: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/roomplan/RoomplanReservation.vue